import { render } from "./Camera.vue?vue&type=template&id=f58564e0&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=f58564e0&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/rethinkrobotics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58564e0"]])

export default __exports__